/***************************************** Slidshow *****************************/

// slideshow
new Swiper("#productSwiper", {
    effect: "fade",
    loop: true,
    navigation: {
        nextEl: '#productSwiperRight,#productSwiperNext',
        prevEl: '#productSwiperLeft',
    },
    pagination: {
        el: '#productSwiperPagination',
        clickable: true
    },
    on: {
        slideChangeTransitionEnd: function () {
            if (document.querySelector(".swiper-slide-active.white")) {
                document.querySelector(".site-header").classList.add("white");
            } else {
                document.querySelector(".site-header").classList.remove("white");
            }
        }
    },
});